import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { logoutUser, qlikLoginSSO } from '../../../redux/actions/authActions';
import Header from '../../layout/Partials/Header';

import Loading from '../../common/Loading';
import ReadMoreReact from 'read-more-react';
import {
    deleteContentRow,
    getContentRows,
    getPage,
    getSecuredPages,
    resetPages,
} from '../../../redux/actions/pagesActions';
import { resetErrors } from '../../../redux/actions/errorsActions';
import {
    deleteObject,
    getObjects,
    resetObjects,
} from '../../../redux/actions/objectsAction';
import { getGroups } from '../../../redux/actions/groupsActions';
import * as lodash from 'lodash';
import axios from 'axios';
import { ToastsStore } from 'react-toasts';
import { Theme } from '../../../utils/Theme';
import AdminContentManager from './Partials/AdminContentManager';
import { withStyles } from '@material-ui/styles';
import AdminLayout from '../../layout/AdminLayout';
import { FormControlLabel, Switch, Box } from '@material-ui/core';
import Section from '../../UI/Section';
import SecurityGroupForm from './Partials/securityGroupForm';

const { isEmpty } = lodash;
const styles = Theme();

class ViewPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            objects: null,
            page: null,
            errors: {},
            loading: true,
            group: '',
            showSecurityGroups: false,
            qlikBaseUrl: null,
            qssOptions: null,
            showResourceDeleteConfirmWindow: false,
            toDelete: {
                type: '',
                id: '',
            },
        };
        this.onChange = this.onChange.bind(this);
        this.onResourceSelect = this.onResourceSelect.bind(this);
        this.onResourceFormSubmit = this.onResourceFormSubmit.bind(this);
    }

    static getDerivedStateFromProps(nextProps) {
        const { pages, objects, errors, qsServer } = nextProps;
        let qssOptions = {};
        const groupOptions = [];

        const { page, content_rows } = pages;

        if (!pages.loading && !qsServer.loading) {
            const server = qsServer.qsServer;

            console.log("server", server);

            if (content_rows && page) {
                page.rows = page.contentRows;
            }
            if (page && server) {
                let qsApp = null;

                //Check App Id Available in the page
                if (page.qsApp !== undefined) {
                    if (!isEmpty(page.qsApp)) {
                        qsApp = page.qsApp;
                    } else {
                        qsApp = server.app;
                    }
                } else {
                    qsApp = server.app;
                }

                const secure = server.secure === 'YES' ? true : false;
                const protocol = secure ? 'https://' : 'http://';
                const port = server.port !== null ? parseInt(server.port) : 80;
                const prefix = isEmpty(server.prefix)
                    ? '/'
                    : `/${server.prefix}/`;
                // const qTicket = localStorage.getItem('qTicket');
                const qlikBaseUrl = `${protocol}${server.hostname}${prefix}`;
                // const qlikLogo = `${qlikBaseUrl}resources/favicon.ico?qlikTicket=${qTicket}`;
                const {tenantUri, webIntegrationId} = server;

                qssOptions = {
                    config: {
                        host: server.hostname,
                        secure: secure,
                        port: port,
                        prefix: server.prefix,
                        appId: qsApp,
                        webIntegrationId,
                        tenantUri,
                    },
                    connections: {
                        vizApi: true,
                        engineApi: true,
                    },
                    qlikBaseUrl,
                };
            }

            if (nextProps.groups && nextProps.groups.groups !== null) {
                const groups = nextProps.groups.groups;

                for (var i = 0; i < groups.length; i++) {
                    groupOptions.push({
                        key: groups[i]._id,
                        title: groups[i].name,
                    });
                }
            }

            return {
                page,
                objects: objects.objects,
                errors,
                qssOptions,
                groupOptions,
                // selectionsBar : {}
                loading: false,
            };
        }

        return { loading: true };
    }

    resourceDeleteConfirmWindow(type, id) {
        this.setState({
            showResourceDeleteConfirmWindow: true,
            toDelete: { type, id },
        });
    }

    resourceDeleteConfirmed() {
        const type = this.state.toDelete.type;
        const id = this.props.match.params.id;
        const group_id = this.state.toDelete.id;

        axios
            .delete(`/api/groups/resources/${type}/${group_id}/${id}`)
            .then((res) => {
                this.setState({
                    showResourceDeleteConfirmWindow: true,
                    toDelete: { type, id },
                });
                this.props.getPage(this.props.match.params.id);
                ToastsStore.success(`Page removed from group`);
            })
            .catch((err) => {
                this.setState({ errors: err.response.data });
            });
    }

    resourceDeleteCancelled() {
        this.setState({
            showResourceDeleteConfirmWindow: false,
            toDelete: { type: '', id: '' },
        });
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onResourceSelect(e) {
        e.preventDefault();
        const group = e.target.value;
        this.setState({ group });
    }

    onResourceFormSubmit(e) {
        e.preventDefault();
        const resourceData = {
            type: 'pages',
            resource_id: this.props.match.params.id,
        };
        const group_id = this.state.group;

        axios
            .post(`/api/groups/resources/${group_id}`, resourceData)
            .then(() => {
                this.props.getPage(resourceData.resource_id);
                ToastsStore.success(`Page added to group.`);
            })
            .catch((err) => {
                ToastsStore.error(`Failed to add page to group ${group_id}`);
            });
    }

    componentDidMount() {
        //CLEAR
        this.props.resetPages();
        this.props.resetErrors();
        this.props.resetObjects();

        this.setState({
            objects: null,
            page: null,
            errors: {},
            loading: true,
        });

        const page_id = this.props.match.params.id;

        //GET PAGE CONTENT
        this.props.getPage(page_id);

        //GET GROUPS
        this.props.getGroups();

        //SET LOADING TO FALSE
        this.setState({ loading: true });
    }

    componentWillUnmount() {
        //this.props.resetObjects()
        this.props.getSecuredPages();
    }

    render() {
        const {
            page,
            objects,
            loading,
            toDelete,
            group,
            qssOptions,
            groupOptions,
            showSecurityGroups,
        } = this.state;
        const { classes } = this.props;

        return (
            <AdminLayout>
                <div className="o-page">
                    <Header title={'Page'} />
                    <Box className="u-m-xsmall full_height">
                        <Section height={'70vh'}>
                            {(loading || isEmpty(page)) && <Loading />}

                            {!loading && !isEmpty(page) && (
                                <div className="u-m-auto">
                                    <div className="u-p-zero u-m-zero">
                                        <div className="o-line u-p-small u-m-small">
                                            <h4 className={`c-card__title `}>
                                                {page.title}
                                            </h4>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={
                                                            this.state
                                                                .showSecurityGroups
                                                        }
                                                        onChange={(event) =>
                                                            this.setState({
                                                                showSecurityGroups:
                                                                    event.target
                                                                        .checked,
                                                            })
                                                        }
                                                        name="showSecurityGroups"
                                                        color="secondary"
                                                    />
                                                }
                                                label={
                                                    showSecurityGroups
                                                        ? 'Manage Content'
                                                        : 'Manage Security Groups'
                                                }
                                            />

                                            <div className="c-dropdown dropdown">
                                                <span
                                                    className={`${classes.buttonPrimary} has-icon dropdown-toggle`}
                                                    id="MoreActionsDropdown"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    More Actions
                                                </span>
                                                <div
                                                    className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                                                    aria-labelledby="MoreActionsDropdown"
                                                >
                                                    <span
                                                        onClick={(e) => {
                                                            this.props.history.goBack();
                                                        }}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Back
                                                    </span>
                                                    <Link
                                                        to={`/pages/${page._id}`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        View In Dashboard
                                                    </Link>
                                                    <Link
                                                        to={`/settings/pages/${page._id}/edit`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Edit Page
                                                    </Link>
                                                    <Link
                                                        to={`/settings/pages/create-row/${page._id}`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        New Row
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                        {page.description && (
                                            <div className="u-pl-small u-pr-small u-pb-small u-ml-small u-mr-small u-mb-small">
                                                <ReadMoreReact
                                                    text={page.description}
                                                    min={0}
                                                    ideal={180}
                                                    max={250}
                                                    readMoreText="Continue Reading."
                                                />
                                            </div>
                                        )}

                                        <div>
                                            {showSecurityGroups && (
                                                <SecurityGroupForm
                                                    classes={classes}
                                                    onResourceFormSubmit={
                                                        this
                                                            .onResourceFormSubmit
                                                    }
                                                    onResourceSelect={
                                                        this.onResourceSelect
                                                    }
                                                    page={page}
                                                    group={group}
                                                    groupOptions={groupOptions}
                                                    resourceDeleteCancelled={
                                                        this
                                                            .resourceDeleteCancelled
                                                    }
                                                    resourceDeleteConfirmed={
                                                        this
                                                            .resourceDeleteConfirmed
                                                    }
                                                    toDelete={toDelete}
                                                />
                                            )}

                                            {!showSecurityGroups &&
                                                qssOptions && (
                                                    <AdminContentManager
                                                        history={
                                                            this.props.history
                                                        }
                                                        objects={objects}
                                                        deleteRowAction={
                                                            this.props
                                                                .deleteContentRow
                                                        }
                                                        deleteObjectAction={
                                                            this.props
                                                                .deleteObject
                                                        }
                                                        qssOptions={qssOptions}
                                                        page={page}
                                                        classes={classes}
                                                    />
                                                )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Section>
                    </Box>
                </div>
            </AdminLayout>
        );
    }
}

ViewPage.propTypes = {
    auth: PropTypes.object.isRequired,
    qlikLoginSSO: PropTypes.func.isRequired,
    getPage: PropTypes.func.isRequired,
    getObjects: PropTypes.func.isRequired,
    getGroups: PropTypes.func.isRequired,
    deleteObject: PropTypes.func.isRequired,
    deleteContentRow: PropTypes.func,
    getContentRows: PropTypes.func,
    resetPages: PropTypes.func,
    resetErrors: PropTypes.func,
    resetObjects: PropTypes.func,
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    qsServer: PropTypes.object,
    objects: PropTypes.object,
    groups: PropTypes.object,
    pages: PropTypes.object,
    errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    pages: state.pages,
    objects: state.objects,
    errors: state.errors,
    loading: state.loading,
    groups: state.groups,
    qsServer: state.qsServer,
});

export default connect(mapStateToProps, {
    qlikLoginSSO,
    getSecuredPages,
    deleteContentRow,
    deleteObject,
    getObjects,
    getPage,
    getGroups,
    logoutUser,
    resetPages,
    resetErrors,
    resetObjects,
    getContentRows,
})(withRouter(withStyles(styles)(ViewPage)));
